// @flow
import React from "react";

export class About extends React.Component {
  render() {
    // return <div>About</div>;
    return <img src="http://localhost:3000/gallery/4.jpg" />;
  }
}



// WEBPACK FOOTER //
// ./src/pages/About.js